import { localStorageFactory } from 'services/localStorage/localStorage.factory';
import { defaultInitialState, State } from 'store/ComparisonListsStore/types';

export const [
  ComparisonListsLocalStorageContext,
  ComparisonListsLocalStorageProvider,
] = localStorageFactory<State>('ComparisonLists', defaultInitialState);
